import { render, staticRenderFns } from "./tour-ticket.vue?vue&type=template&id=8ba104f0"
import script from "./tour-ticket.vue?vue&type=script&lang=js"
export * from "./tour-ticket.vue?vue&type=script&lang=js"
import style0 from "./tour-ticket.vue?vue&type=style&index=0&id=8ba104f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports